import React from 'react';
import PropTypes from 'prop-types';

export default function ArrowIcon(props) {
  const { fill, width, height, className } = props;

  return (
    <svg
      xmlns='http://www.w3.org/2000/svg'
      width={width}
      height={height}
      viewBox='0 0 18.641 8.823'
      className={className}
    >
      <path
        id='Caminho_11921'
        data-name='Caminho 11921'
        d='M637.882,1639.6a1.168,1.168,0,0,1-1.453,0l-8.157-6.492a1.165,1.165,0,1,1,1.45-1.824l7.43,5.913,7.43-5.913a1.165,1.165,0,1,1,1.45,1.824Z'
        transform='translate(-627.832 -1631.03)'
        fill={fill}
      />
    </svg>
  );
}

ArrowIcon.defaultProps = {
  fill: '#cacaca',
  width: 18.641,
  height: 8.823
};

ArrowIcon.propTypes = {
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  className: PropTypes.string
};
